import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedOrderAllocations: [],
};

const orderAllocationsSlice = createSlice({
	name: 'orderAllocations',
	initialState: initialState,
	reducers: {
		setOrderAllocations: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setOrderAllocations, reset } = orderAllocationsSlice.actions;

export default orderAllocationsSlice.reducer;